import { featured } from '@/mocks/manhwa';

export default function Featured() {
  return (
    <section id="featured" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-lg bg-background-100/70">
          <div className="grid lg:grid-cols-2">
            <div className="relative h-[280px] lg:h-auto">
              <img
                src={featured.image}
                alt={`${featured.title} 编辑推荐专题主图`}
                title={`${featured.title} 漫画韩国下拉式编辑推荐`}
                className="h-full w-full object-cover object-top"
              />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-medal-fill" />
                {featured.tagline}
              </span>
            </div>
            <div className="flex flex-col justify-center p-6 md:p-10">
              <span className="text-xs font-medium tracking-wide text-primary-600">{featured.category}</span>
              <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">{featured.title}</h2>
              <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-600">
                <span className="flex items-center gap-1"><i className="ri-fire-fill text-primary-500" />热度 {featured.heat}</span>
                <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-500" />{featured.rating} 分</span>
                <span className="text-secondary-700">{featured.chapters}</span>
                <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-800">{featured.group}</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{featured.intro}</p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#hot"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-center text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  立即阅读
                </a>
                <a
                  href="#hot"
                  className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-center text-sm font-bold text-foreground-800 transition-colors hover:bg-background-200"
                >
                  收藏这部连载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}